import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {BehaviorSubject, from, Subject, Subscription, takeUntil} from 'rxjs';
import {GalleryService} from '../../../../services/gallery.service';
import {VkService} from '../../../../pages/page-vk/vk.service';
import {AllService} from '../../../../services/all.service';
import {IMessengerConnector} from '../../../../types/all.type';
import {distinctUntilChanged} from "rxjs/operators";
import {UnsubscriberService} from '../../../../services/unsubscriber.service';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() caption = '';
  @Input() styles: any = {};
  @Input() Service: IMessengerConnector;
  @Input() attachment: any;
  @Input() round = false;

  @Input() vizible: boolean;
  @Input() width = '100%';
  @Input() play = 'auto';
  @Input() mode: 'inline' | 'thumb' = 'inline';
  public isPlay = false;
  @ViewChild('bunnyVideo', {read: ElementRef}) bunnyVideo: ElementRef;

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.isPlay && this.videoPlay();
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    this.videoPause();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.play === 'hover') {
      this.videoPlay();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.play === 'hover') {
      this.videoPause();
    }
  }

  public video: HTMLVideoElement;
  public timeRemaining: BehaviorSubject<string> = new BehaviorSubject('-00:00');

  constructor(
    public allService: AllService,
    public galleryService: GalleryService,
    private cd: ChangeDetectorRef,
    private zone: NgZone
  ) {
  }

  ngOnInit(): void {
    if (this.attachment.mime_type === 'video/quicktime') {
      this.attachment.mime_type = 'video/mp4';
    }
    this.galleryService.addToGallery(this.attachment);
    this.cd.detach();
    this.cd.detectChanges();
  }

  get isMuted() {
    return this.video && this.video.muted;
  }

  toggleMuted(event) {
    if (this.round) {
      event.preventDefault();
      if (this.isMuted) {
        this.video.currentTime = 0;
        this.video.muted = false;
        this.video.play();
      } else {
        this.videoPause();
        this.video.muted = true;
      }
    } else {
      // TODO
      this.galleryService.openGallery(event, this.attachment.file_uri);
    }
  }

  public loadVideoError(event) {
    // this.attachment.file_uri = undefined;
    this.attachment.file_uri_error = true;
    this.cd.detectChanges();
  }

  private setTimeRemaining(d: number, t: number): void {
    let remaining;
    const timeLeft = d - t,
      seconds = Math.floor(timeLeft % 60) || 0,
      remainingSeconds = seconds < 10 ? '0' + seconds : seconds,
      minutes = Math.floor((timeLeft / 60) % 60) || 0,
      remainingMinutes = minutes < 10 ? '0' + minutes : minutes,
      hours = Math.floor((timeLeft / 60 / 60) % 60) || 0;

    if (hours === 0) {
      remaining = '-' + remainingMinutes + ':' + remainingSeconds;
    } else {
      remaining = '-' + hours + ':' + remainingMinutes + ':' + remainingSeconds;
    }
    this.cd.detectChanges();
    this.timeRemaining.next(remaining);
  }

  videoInit() {
    if (!this.attachment.file_uri) {
      this.Service.getFileSrc(this.attachment);
    }
    if (this.mode === 'inline') {
      this.cd.detectChanges();
      this.video = this.bunnyVideo.nativeElement;
      this.video.muted = true;
      if (this.play === 'auto') {
        this.videoPlay();
      }
      this.zone.runOutsideAngular(() => {
        this.video.addEventListener('timeupdate', this.calculateTime, false);
      });
    }

    if (this.mode === 'thumb' && this.attachment?.thumb && !this.attachment?.thumb?.file_uri) {
      if (!(this.Service instanceof VkService)) {
        this.Service.getFile$(this.attachment.thumb.file_id, this.attachment.thumb.file_unique_id)
          .pipe(takeUntil(this.destroy$))
          .subscribe((result: any) => {
            // tag("getFile$")
            this.attachment.thumb.file_uri = result.file;
            this.cd.detectChanges();
          });
      }
    }
    this.cd.detectChanges();
  }

  videoPlay() {
    if (this.video) {
      this.isPlay = true;
      this.video.play().catch((err) => {
        this.cd.detectChanges();
      });
    }
  }

  videoPause() {
    this.isPlay = false;
    this.video && this.video.pause();
  }

  private calculateTime = (evt) => {
    const ct = this.video.currentTime;
    const d = this.video.duration;
    this.setTimeRemaining(d, ct);
  }

  loadImageAttachmentError(event, attachment) {
    attachment.thumb.file_uri = undefined;
    attachment.thumb.file_uri_error = true;
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
